import React, { useRef } from 'react';
import { connect } from 'react-redux';
import IdleTimer from 'react-idle-timer';
import { Button } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import useStyles from '../../assets/jss/modal-styles';
import action from '../../reduxStore/action';

const UseIdleTimer = (props) => {
  const { logout } = props;
  const idleTimerRef = useRef(null);
  const sessionTimeOutRef = useRef(null);
  const [open, setOpen] = React.useState(false);
  const modalStyles = useStyles();

  // Modal Functions
  const handleOpen = () => {
    setOpen(true);
  };
  const stayActive = () => {
    setOpen(false);
    clearTimeout(sessionTimeOutRef.current);
  };
  // END MODAL functions
  const onIdle = () => {
    handleOpen();
    sessionTimeOutRef.current = setTimeout(logoutHelper, 60000); // Log out After 1 min once modal is displayed.
  };

  const logoutHelper = () => {
    setOpen(false);
    clearTimeout(sessionTimeOutRef.current);
    logout();
  };

  return (
    <>
      <IdleTimer
        ref={idleTimerRef}
        element={document}
        onIdle={onIdle}
        debounce={250}
        timeout={1200000} // 5-min ** change me!! set for DEV
      />
      <Modal open={open} onClose={stayActive}>
        <div className={modalStyles.paper}>
          <h4 className={modalStyles.modalTitle}>{'Still There?'}</h4>
          <p>{'The session will be expiring soon.'}</p>
          <div className={modalStyles.buttonContainer}>
            <Button type='submit' variant='contained' color='primary' onClick={logoutHelper}>
              {'log Out'}
            </Button>
            <Button type='submit' variant='contained' color='primary' onClick={stayActive}>
              {'Stay Active'}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default connect(null, action)(UseIdleTimer);
